import { render, staticRenderFns } from "./Proposal.vue?vue&type=template&id=22fa342c&scoped=true"
import script from "./Proposal.vue?vue&type=script&lang=js"
export * from "./Proposal.vue?vue&type=script&lang=js"
import style0 from "./Proposal.vue?vue&type=style&index=0&id=22fa342c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fa342c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fa342c')) {
      api.createRecord('22fa342c', component.options)
    } else {
      api.reload('22fa342c', component.options)
    }
    module.hot.accept("./Proposal.vue?vue&type=template&id=22fa342c&scoped=true", function () {
      api.rerender('22fa342c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Proposal.vue"
export default component.exports